export default __webpack_public_path__ + "static/media/img-0016.a48d9008.png";